import { useState } from 'react';
import { useSelector } from 'react-redux';

import classes from './Notification.module.scss';

import notification from '../../assets/svgs/notification.svg';

export default function Notification() {
  const [isShow, setIsShow] = useState(false);
  const isLogedIn = useSelector((state) => state.authentication.isLogedIn);

  const cliclHandler = () => {
    setIsShow((prev) => !prev);
  };

  return (
    <div className="notification-container" onClick={cliclHandler}>
      <img
        src={notification}
        alt=""
        className={`${classes['bell-icon']} ${isShow ? classes.active : ''}`}
      />

      {isShow && (
        <div
          className={`${classes['notification-popup']} ${
            isLogedIn ? classes['logedin'] : ''
          }`}
        >
          <div className={classes['notification-item']}>
            <p>
              <strong>From: Halley Team</strong>
            </p>
            <p>Please check your notifications!</p>
            <div className={classes['notification-footer']}>
              <span>8/11/2024 17:58</span>
              <i className="fa fa-eye"></i>
            </div>
          </div>
          <div className={classes['notification-item']}>
            <p>
              <strong>From: Halley Team</strong>
            </p>
            <p>Hello, Welcome to our application.</p>
            <div className={classes['notification-footer']}>
              <span>8/03/2024 22:01</span>
              <i className="fa fa-eye"></i>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
